export default "__VITE_ASSET__BmsWW9$V__"